import { BitkitTabs } from '@bitrise/bitkit-v2';

import { trackTestCaseDetailsViewed } from '../../TestResults.tracking';
import { Attachment } from '../../TestResults.types';
import AttachmentsTab from './AttachmentsTab/AttachmentsTab';
import TestOutputTab from './TestOutputTab/TestOutputTab';

const TestCaseDetailsTabs = ({ testOutput, attachments }: { testOutput?: string; attachments?: Attachment[] }) => {
  const numOfAttachments = attachments?.length ?? 0;

  return (
    <BitkitTabs.Root
      defaultValue="test_output"
      lazyMount
      onValueChange={({ value }) => trackTestCaseDetailsViewed({ detailType: value })}
      unmountOnExit
    >
      <BitkitTabs.List background="background/primary">
        <BitkitTabs.Trigger value="test_output">Test output</BitkitTabs.Trigger>
        {attachments && (
          <BitkitTabs.Trigger value="attachments">
            {`Attachments${numOfAttachments > 0 ? ` (${numOfAttachments})` : ''}`}
          </BitkitTabs.Trigger>
        )}
      </BitkitTabs.List>
      <BitkitTabs.ContentGroup>
        <TestOutputTab content={testOutput || 'No output available.'} />
        {attachments && <AttachmentsTab attachments={attachments} />}
      </BitkitTabs.ContentGroup>
    </BitkitTabs.Root>
  );
};

export default TestCaseDetailsTabs;
